import { AlertCircle } from "lucide-react";

interface DocToHtmlErrorBannerProps {
  message?: string;
}

export function DocToHtmlErrorBanner({ message }: DocToHtmlErrorBannerProps) {
  return (
    <div className="flex items-center justify-center flex-auto">
      <div className="flex items-center gap-3 p-4 bg-red-50 border border-red-200 rounded-lg max-w-md">
        <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0" />
        <div>
          <p className="text-sm font-medium text-red-900">Error loading form</p>
          {message && (
            <p className="text-xs text-red-700 mt-1">{message}</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default DocToHtmlErrorBanner;
